import React from 'react'
import {Form, Input, Layout, message, Table} from 'antd';
import {dispute_approval_item, downloadAttachment, getAttachment} from "../../requist";
import {download} from "ant-design-icons";

class DisputeSummary extends React.Component{
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state={
            disputeNo:'',
            region:'',
            businessUnit:'',
            dataSource:[],
            data:'',
            fileName:[],
            fileCategory:[],
            fileId:[],
            disputeNumber:[],
            disputeType:''
        }
        this.columns=[
            {
                title: 'Item No',
                dataIndex: 'disputeItemNo',
                width:250,
            },
            {
                title: 'Invoice NO',
                dataIndex: 'invoiceNo',
                width:250,
            },
            {
                title: 'Invoice Item No',
                dataIndex: 'invoiceItemNo',
                width:250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'PO Number',
                dataIndex: 'poNumber',
                width:250,
            },
            {
                title: 'Delivery Number',
                dataIndex: 'deliveryNumber',
                width:250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'Order Number',
                dataIndex: 'orderNumber',
                width:250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'Part Number',
                dataIndex: 'partNumber',
                width:250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'Quantity',
                dataIndex: 'quantity',
                width:250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'Credit Amount Per Unit',
                dataIndex: 'creditAmountUnit',
                width:250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'Credit Amount Total',
                dataIndex: 'creditAmountTotal',
                width:250,
                // render:(text)=>{
                //     const {disputeType,totalAmount}=this.state;
                //     if(disputeType==='REBI' || disputeType==='INVD'){
                //         return totalAmount
                //     }else {
                //         return text
                //     }
                // }

            },
            {
                title: 'Currency',
                dataIndex: 'currency',
                width:250,
            },
            {
                title: 'Serial Numbers',
                dataIndex: 'serialNumbers',
                width:250,
                render:(text)=>{
                    const {disputeType}=this.state;
                    if(disputeType==='REBI' || disputeType==='INVD'){
                        return 'NA'
                    }else {
                        return text
                    }
                }
            },
            {
                title: 'Price Drop Date',
                dataIndex: 'priceDropDate',
                width:250,
            },
            {
                title: 'Also Product damaged',
                dataIndex: 'productDamaged',
                width:250,
            },
            {
                title: 'BIOS Password',
                dataIndex: 'biosPassword',
                width:250,
            },
        ]
    }
    getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }
    componentDidMount() {
        let disputeNo = this.getQueryString('DP')
        // let disputeNo = 'DP00000850'
        this.setState({disputeNo:disputeNo})
        disputeNo && dispute_approval_item(disputeNo).then(res=>{
            const {data,retCode,retMsg} = res;
            if(retCode==="200"){
                this.setState({
                    data:data,
                    dataSource:data.items,
                    region:data.region,
                    businessUnit:data.businessUnit,
                    disputeType:data.disputeType,
                    totalAmount:data.totalAmount
                })
            }else{
                message.error(`${retMsg}`)
            }
        })
        disputeNo && getAttachment(disputeNo).then(res=>{
            const {data,retCode,retMsg} = res;
            if(retCode==="200"){
                let fileNameList=[];
                let fileCategoryList=[];
                let fileIdList=[];
                let disputeNumberList=[];
                data.map(item=>{
                    fileNameList.push(item.fileName)
                    fileCategoryList.push(item.fileCategory)
                    fileIdList.push(item.fileId)
                    disputeNumberList.push(item.disputeNo)
                })
                this.setState({
                    fileName:fileNameList,
                    fileCategory:fileCategoryList,
                    fileId:fileIdList,
                    disputeNumber:disputeNumberList
                })
            }else{
                message.error(`${retMsg}`)
            }
        })
    }
    downloadAttachmentFile=(e)=>{
        let params = e.target.innerHTML;
        downloadAttachment(params).then(res=>{
            let URL = window.URL || window.webkitURL;
            let objectUrl = URL.createObjectURL(res);
            let a = document.createElement('a');
            a.href = objectUrl;
            a.download = params;
            document.body.appendChild(a);
            a.click();
            a.remove();
        })
    }

    render() {
        let userType = window.localStorage.getItem('userType')
        const {disputeNo,dataSource,region,businessUnit,data,fileName,fileCategory,fileId,disputeNumber}=this.state
        return <div>
            <Layout className="site-layout-background" style={{ padding: '24px 0',margin: '0 auto' }}>
                <h2>{disputeNo} ({region}/{businessUnit==="P"?'PCG':'DCG'})</h2>
                <Form
                    name="Dispute-Summary"
                    labelCol={{ span: 8 , offset:0}}
                    wrapperCol={{ span: 10}}
                    ref={this.formRef}
                >
                    <Form.Item
                        label="Dispute Type"
                        name="disputeTypeText"
                    >
                        <strong>{data.disputeTypeText}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Sold To"
                        name="soldTo"
                    >
                        <strong>{data.soldTo}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Create At"
                        name="createdAt"
                    >
                        <strong>{data.createdAt}</strong>
                    </Form.Item>
                    <Form.Item
                        label="status"
                        name="status"
                    >
                        <strong>{data.statusText}</strong>
                    </Form.Item>
                    <Table
                        scroll={{y: 500}}
                        bordered
                        rowKey={'id'}
                        dataSource={dataSource}
                        columns={this.columns}
                    />
                    <h1 className={'big_title'}>Dispute Details</h1>
                    <Form.Item
                        label="Text To Appear On Credit Note"
                        name="textOnCreditNote"
                    >
                        <strong>{data.textOnCreditNote}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Requested Changes"
                        name="requestedChanges"
                    >
                        <strong>{data.requestedChanges}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Reason Description"
                        name="reasonDescription"
                    >
                        <strong>{data.reasonDescription}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Requested VAT ID"
                        name="requestVatId"
                    >
                        <strong>{data.requestVatId}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Customer's Comments"
                        name="comments"
                    >
                        <strong>{data.comments}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Customer Internal Reference"
                        name="customerInternalRef"
                    >
                        <strong>{data.customerInternalRef}</strong>
                    </Form.Item>
                    <h1 className={'big_title'}>Attachment</h1>
                    <Form.Item
                        label="Download Attachment"
                        name="productDamaged"
                    >
                        <strong>
                            {
                                disputeNumber.map((item,index)=>{
                                    if (fileCategory[index] === 'APPAT' && userType === 'external') {
                                        return;
                                    }
                                    return <a style={{display:'block'}} onClick={this.downloadAttachmentFile}>{item+'_'+fileCategory[index]+fileId[index]+'_'+fileName[index]}</a>
                                })
                            }
                        </strong>
                    </Form.Item>
                    <h1 className={'big_title'}>Dispute Requestor</h1>
                    <Form.Item
                        label="Requestor"
                        name="requesterId"
                    >
                        <strong>{data.requesterId}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Phone Number"
                        name="requesterPhoneNo"
                    >
                        <strong>{data.requesterPhoneNo}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Email Address"
                        name="requesterEmail"
                    >
                        <strong>{data.requesterEmail}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Company"
                        name="requesterCompany"
                    >
                        <strong>{data.requesterCompany}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Country"
                        name="requesterCountry"
                    >
                        <strong>{data.requesterCountry}</strong>
                    </Form.Item>
                    <h1 className={'big_title'}>Collection Details</h1>
                    <Form.Item
                        label="Contact Person"
                        name="contactPerson"
                    >
                        <strong>{data.contactPerson}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Phone Number"
                        name="contactPersonPhone"
                    >
                        <strong>{data.contactPersonPhone}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Email Address"
                        name="contactPersonEmail"
                    >
                        <strong>{data.contactPersonEmail}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Company"
                        name="contactPersonCompany"
                    >
                        <strong>{data.contactPersonCompany}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Street"
                        name="contactPersonStreet"
                    >
                        <strong>{data.contactPersonStreet}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Zip Code"
                        name="contactPersonZipCode"
                    >
                        <strong>{data.contactPersonZipCode}</strong>
                    </Form.Item>
                    <Form.Item
                        label="City"
                        name="contactPersonCity"
                    >
                        <strong>{data.contactPersonCity}</strong>
                    </Form.Item>
                    <Form.Item
                        label="Country"
                        name="contactPersonCountry"
                    >
                        <strong>{data.contactPersonCountry}</strong>
                    </Form.Item>
                </Form>

            </Layout>
        </div>
    }
}

export default DisputeSummary;